import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const logoUrl = "https://assets.auxodev.dk/assets/933ba291-d562-4801-b20a-fae6de561b45/logo.png";

  return (
    <footer className="bg-[#1F2A37] text-white pt-16 pb-8 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-gray-800">
          
          {/* Brand & Info */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img 
                src={logoUrl} 
                alt="Fyns - Tømreren ApS logo – Din lokale tømrer i Munkebo og på hele Fyn" 
                className="h-20 w-auto object-contain bg-white p-1.5"
              />
            </Link>
            <div className="text-xs text-gray-400 font-medium pt-1">
              CVR: 34704201
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-semibold text-white mb-4 border-l-2 border-[#3A5A40] pl-3">
              Hurtige links
            </h3>
            <ul className="space-y-2.5 text-sm text-gray-300">
              <li>
                <Link to="/" className="hover:text-white hover:underline transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-white hover:underline transition-colors">
                  Galleri & Projekter
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-white hover:underline transition-colors">
                  Om virksomheden
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-white hover:underline transition-colors">
                  Kontakt os
                </Link>
              </li>
            </ul>
          </div>

          {/* Ydelser Links */}
          <div>
            <h3 className="text-base font-semibold text-white mb-4 border-l-2 border-[#3A5A40] pl-3">
              Vores speciale
            </h3>
            <ul className="space-y-2.5 text-sm text-gray-300">
              <li>
                <Link to="/ydelser/tag-facade" className="hover:text-white hover:underline transition-colors">
                  Tag & Facade
                </Link>
              </li>
              <li>
                <Link to="/ydelser/interior-gulve" className="hover:text-white hover:underline transition-colors">
                  Interiør & Gulve
                </Link>
              </li>
              <li>
                <Link to="/ydelser/koekken-inventar" className="hover:text-white hover:underline transition-colors">
                  Køkken & Inventar
                </Link>
              </li>
              <li>
                <Link to="/ydelser/asbestsanering" className="hover:text-white hover:underline transition-colors">
                  Autoriseret Asbestsanering
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h3 className="text-base font-semibold text-white mb-4 border-l-2 border-[#3A5A40] pl-3">
              Kontaktinformation
            </h3>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-white mt-1"></i>
                <span>Fjordvej 103, 5330 Munkebo</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-white"></i>
                <a href="tel:60715018" className="hover:text-white transition-colors whitespace-nowrap">
                  60 71 50 18
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-white"></i>
                <a href="mailto:fynstomreren@gmail.com" className="hover:text-white transition-colors whitespace-nowrap">
                  fynstomreren@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-clock text-white mt-1"></i>
                <span>Mandag - Fredag: 07:00 - 16:30</span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-gray-400 gap-4">
          <p>© {new Date().getFullYear()} Fyns - Tømreren ApS. Alle rettigheder forbeholdes.</p>
          <p>CVR: 34704201 • Munkebo, Fyn</p>
        </div>
      </div>
    </footer>
  );
}
